import { Fragment } from "react";
import { Projects } from "../../../ProjectData";

function Recent({ changeProject }) {
  return (
    <div className="project-list">
      <h2 className="mobile-title">Recent Work:</h2>
      {Projects.map((project, index) => (
        <Fragment key={project.key}>
          <a
            className="project-titles"
            href={`recent/${project.route}`}
            onClick={() => changeProject(project.key)}
          >
            {project.title} &#187;
          </a>
          {index < Projects.length - 1 && <br />}
        </Fragment>
      ))}
    </div>
  );
}

export default Recent;
